import {
  addGlobalContexts,
  enableActivityTracking,
  newTracker,
  removeGlobalContexts,
  setUserId,
} from '@snowplow/browser-tracker'
import { userContextSchema } from './schema'

export const initTracker = () => {
  if (!process.env.SNOWPLOW_API_URL) return

  const tracker = newTracker('analytic', process.env.SNOWPLOW_API_URL, {
    appId: process.env.SNOWPLOW_APP_ID,
  })

  enableActivityTracking(
    {
      minimumVisitLength: 30,
      heartbeatDelay: 10,
    },
    [tracker?.id]
  )

  return tracker
}

export const setUserProperties = (
  params: Partial<{
    user_id: number
    gender: number
    user_age: number
    followers_count: number
    followings_count: number
    created_at: number
    age_verified: boolean
  }>
) => {
  setUserId((params.user_id ?? '').toString())

  if (params.user_id) {
    addGlobalContexts([
      userContextSchema({
        user_id: params.user_id,
        gender: params.gender,
        age: params.user_age,
        follower_number: params.followers_count,
        following_number: params.followings_count,
        account_create_at_time: (params.created_at ?? '').toString(),
        is_verifiy_account: params.age_verified,
      }),
    ])
  } else {
    removeGlobalContexts([userContextSchema({})])
  }
}

export type BrowserTracker = ReturnType<typeof newTracker>
export { trackPageView } from '@snowplow/browser-tracker'

export type SnowplowTempStorage = {
  type: 'login'
  id?: number
}
